import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import api from "../../api/axios.js";
import { useAuth } from "../../AuthContext.js";
import '../../App.css';
import { Link } from "react-router-dom";


export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const { setUser } = useAuth();

  const handleLogin = async () => {
    setError("");
    try {
      const response = await api.post("/login", { email, password });
      const { access_token, user } = response.data;

      localStorage.setItem("token", access_token);
      localStorage.setItem("user", JSON.stringify(user));

      setUser(user);

      const userType = user.role;

      if (userType === "client") {
        navigate("/dashboard-Client", { replace: true });
        toast.success("تم تسجيل الدخول بنجاح كـ عميل");
      } else if (userType === "user") {
        navigate("/dashboard-usersWorks", { replace: true });
        toast.success("تم تسجيل الدخول بنجاح");
      } else {
        setError("نوع المستخدم غير معروف");
      }
    } catch (err) {
      setError(err.response?.data?.message || "فشل تسجيل الدخول");
    }
  };

  

  return (
    <div style={styles.container}>
      <div style={styles.topContent}>
        <img
          src="/images/logo.png"
          alt="شعار الوسيط القضائي"
          className="welcome-image"
        />
        <h2 style={styles.welcomeText}>مرحبا بعودتك ⚖️</h2>
        <p>سجل الدخول إلى حسابك</p>
      </div>

      <div style={styles.card}>
        <input
          type="email"
          placeholder="البريد الإلكتروني"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          style={styles.input}
        />

        <input
          type="password"
          placeholder="كلمة المرور"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          style={styles.input}
        />

        {error && <p style={styles.error}>{error}</p>}

<button onClick={handleLogin} style={styles.button} aria-label="تسجيل الدخول">
  تسجيل الدخول
</button>


        <p style={styles.link}>
  لا تملك حساباً؟{" "}
  <Link style={{ color: "#81df43ff" }} to="/register">
    أنشئ حساباً
  </Link>
</p>
      </div>
    </div>
  );
}

const styles = {
  
  container: {
    backgroundColor: "#e8eee7ff",
    height: "100vh",
    minHeight: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    fontFamily: "'Cairo', sans-serif",
    padding: "20px",
  },
  topContent: {
    textAlign: "center",
    marginBottom: "20px",
  },
  welcomeText: {
    fontSize: "1.2rem",
    color: "#0f172a",
    marginBottom: "20px",
  },
  card: {
    backgroundColor: "#fff",
    padding: "2rem",
    borderRadius: "12px",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
    width: "100%",
    maxWidth: "400px",
    textAlign: "center",
  },
  input: {
    width: "100%",
    padding: "10px",
    marginBottom: "15px",
    borderRadius: "6px",
    border: "1px solid #ccc",
    fontSize: "1rem",
  },
  button: {
    backgroundColor: "#81df43ff",
    color: "#fff",
    padding: "10px 20px",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    width: "100%",
    fontSize: "1rem",
  },
  error: {
    color: "red",
    marginBottom: "10px",
    fontSize: "0.9rem",
  },
  link: {
    marginTop: "1rem",
    fontSize: "0.9rem",
  },
};
